const storage = typeof window !== 'undefined' ? sessionStorage : {
  getItem: (_: string) => null,
  setItem: (_: string, __: string) => {},
  removeItem: (_: string) => {}
}

export function getSecureItem(key: string): string | null {
  try {
    return storage.getItem(key)
  } catch (err) {
    console.error('secureStorage getItem error', err)
    return null
  }
}

export function setSecureItem(key: string, value: string) {
  try {
    storage.setItem(key, value)
  } catch (err) {
    console.error('secureStorage setItem error', err)
  }
}

export function removeSecureItem(key: string) {
  try {
    storage.removeItem(key)
  } catch (err) {
    console.error('secureStorage removeItem error', err)
  }
}
